import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { CssTextField } from "../styles/styles";
import { AddAPhoto, Delete } from "@mui/icons-material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopTimePicker } from "@mui/x-date-pickers";

function ActivacionAddComponents({
    mobile, titulo, setTitulo, imagen, setImagen, handleCancelar, handleGuardar,
    handleAgregarImagen, fechaInicio, handleFechaInicio, fechaFin, handleFechaFin,
    horaInicio, handleHoraInicio, horaFin, handleHoraFin
}) {
    const [imageSelected, setImageSelected] = useState(0);

    const matchesMobile = useMediaQuery('(min-width:1200px)');


    let history = useNavigate();


    //si hay imagenes, se selecciona la primera por defecto






    return (
        <Box>
            <Box sx={{}}>
                <Box sx={{
                    display: 'flex',
                }}>
                    <div style={{}}>
                        {imagen !== '' ? (
                            <div style={{}}>
                                <div style={{
                                    zIndex: 1,
                                    position: 'absolute',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: 500
                                }}>
                                    <IconButton aria-label="delete" onClick={() => setImagen('')}>
                                        <Delete
                                            color="info"
                                            fontSize="large"
                                            style={{ color: PaletaColor.BLANCO }}
                                        />
                                    </IconButton>
                                </div>

                                <img
                                    src={imagen}
                                    alt={'imagen'}
                                    style={{
                                        width: 500,
                                        height: undefined,
                                        borderRadius: 25,
                                        aspectRatio: 1,
                                        objectFit: 'cover',
                                    }}
                                />
                            </div>
                        )
                            :
                            <div style={{
                                width: 500,
                                height: 500,
                                borderRadius: 25,
                                backgroundColor: PaletaColor.COLOR_BACKGROUND_GRIS_CLARO,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}>
                                    <Typography variant={'h6'} style={{ color: PaletaColor.NEGRO }}>
                                        No hay imagen
                                    </Typography>

                                    <Typography variant={'subtitle1'} style={{ color: PaletaColor.NEGRO, marginBottom: Padding.P2 }}>
                                        Tamaño: 720 * 400
                                    </Typography>


                                    <input
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        id="file-input"
                                        onChange={handleAgregarImagen}
                                    />

                                    <label htmlFor="file-input">
                                        <Button
                                            variant="contained"
                                            component="span"
                                            style={{
                                                backgroundColor: PaletaColor.AZUL_OSCURO,
                                                color: PaletaColor.BLANCO,
                                                fontWeight: 'bold',
                                                // height: 50
                                            }}
                                            startIcon={<AddAPhoto />}
                                        >
                                            Agregar
                                        </Button>
                                    </label>
                                </div>
                            </div>
                        }


                    </div>

                    <div style={{
                        // marginLeft: 20,
                        width: '100%',
                        paddingLeft: 20,
                    }}>

                        <CssTextField
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Nombre de la Activación"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                width: '70%'
                            }}
                        />


                        <div style={{ marginTop: Padding.P1, display: 'flex', justifyContent: 'space-between', width: '70%' }}>
                            <div style={{ marginTop: Padding.P1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        label="Fecha de inicio"
                                        value={fechaInicio}
                                        onChange={(newValue) => {
                                            handleFechaInicio(newValue);
                                        }}
                                        format="DD/MM/YYYY"
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ marginTop: Padding.P1, marginLeft: Padding.P1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DesktopTimePicker
                                        label="Hora de inicio"
                                        //que sea 24 horas
                                        ampm={false}
                                        value={horaInicio}
                                        onChange={(newValue) => {
                                            handleHoraInicio(newValue);
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ marginTop: Padding.P1, marginLeft: Padding.P1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        label="Fecha de fin"
                                        value={fechaFin}
                                        onChange={(newValue) => {
                                            handleFechaFin(newValue);
                                        }}
                                        format="DD/MM/YYYY"
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ marginTop: Padding.P1, marginLeft: Padding.P1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>


                                    <DesktopTimePicker
                                        label="Hora de fin"
                                        //que sea 24 horas
                                        ampm={false}
                                        value={horaFin}
                                        onChange={(newValue) => {
                                            handleHoraFin(newValue);
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>


                        <Stack direction="row" spacing={5} style={{ marginTop: Padding.P3 }}>
                            <Button variant="contained" onClick={handleGuardar}>
                                Guardar
                            </Button>

                            <Button variant="outlined" onClick={handleCancelar}>
                                Cancelar
                            </Button>
                        </Stack>





                    </div>
                </Box>
            </Box>
        </Box>
    )
}

export default ActivacionAddComponents;